import { getReportingApiBaseUrl } from "../config/apiBaseUrls";
import { fetchWithAuth } from "../utils/fetchWithAuth";

export async function getMyAgentSettings() {
  const url = `${getReportingApiBaseUrl()}/api/AgentSettings/GetMySettings`;
  const resp = await fetchWithAuth(url, { method: "GET" });
  if (!resp.ok) {
    throw new Error(`GetMySettings ${resp.status}`);
  }
  return resp.json();
}

export async function saveMyAgentSettings(body) {
  const url = `${getReportingApiBaseUrl()}/api/AgentSettings/SaveMySettings`;
  const resp = await fetchWithAuth(url, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    throw new Error(`SaveMySettings ${resp.status}`);
  }
  return resp.json();
}
